import { isValidUrl } from "helpers/helper";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  sendCheckOnlineId,
  sendCheckOnlineIdExist,
} from "features/common/layouts/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { notifyWarning, notifyError } from "components/ToastMessage";

const defaultForm = {
  domainForwarder: null,
  activateLater: false,
  onlineId: "",
};

const ModalBundleDomain = (props) => {
  const dispatch = useDispatch();
  const { defaultOnlineId } = props;
  const { status, error, data } = useSelector(
    (state) => state.cart.availableOnlineId
  );
  const { status_login: isLogin, data_login: dataLogin } = useSelector(
    (state) => state.auth
  );
  const { exist: onlineIdExist, status: existStatus } = useSelector(
    (state) => state.cart.onlineIdCheckExist
  );

  const [isChecking, setIsChecking] = useState(false);
  const [form, setForm] = useState({
    ...defaultForm,
    onlineId: !isLogin ? defaultOnlineId : "",
    domainForwarder: defaultForm.domainForwarder || "",
  });

  useEffect(() => {
    setIsChecking(status === "loading");
  }, [status]);

  useEffect(() => {
    if (isLogin && existStatus === "fulfilled") {
      setForm((prevState) => ({
        ...prevState,
        onlineId: !onlineIdExist ? defaultOnlineId : "",
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogin, existStatus]);

  useEffect(() => {
    if (isLogin && dataLogin) {
      const { user } = dataLogin;

      if (user && user.email) {
        const email = user.email;
        dispatch(sendCheckOnlineIdExist(email));
      }
    }
  }, [isLogin, dataLogin, dispatch]);

  useEffect(() => {
    if (error) {
      notifyError("an error occured! " + error);
    }
  }, [error]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      if (!isChecking && form.onlineId) {
        if (!/^[0-9A-Za-z.\-_]+$/u.test(form.onlineId)) {
          notifyWarning(
            "Online.id hanya boleh berisi huruf, angka, strip, garis bawah dan titik.!"
          );
          return;
        }

        dispatch(sendCheckOnlineId(form.onlineId));
      }
    }, 800);

    return () => clearTimeout(debounce);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.onlineId]);

  const handleDomainForwarder = (e) => {
    setForm((prev) => ({
      ...prev,
      domainForwarder: e.target.value,
    }));
  };

  const handleOnlineId = (e) => {
    setForm((prev) => ({
      ...prev,
      onlineId: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();

    if (form.domainForwarder && form.domainForwarder !== "Activate Later") {
      if (!isValidUrl(form.domainForwarder)) {
        notifyWarning("Domain forwarder bukan url yang valid.!");
        return;
      }
    }

    if (form.onlineId) {
      if (!/^[0-9A-Za-z.\-_]+$/u.test(form.onlineId)) {
        notifyWarning(
          "Online.id hanya boleh berisi huruf, angka, strip, garis bawah dan titik.!"
        );
        return;
      }
    }

    if (form.domainForwarder === null) {
      form.domainForwarder = "Activate Later";
    }

    props.onFormSubmited(form);
  };

  const handleCheck = (e) => {
    if (!form.onlineId) {
      notifyWarning("field Online.id tidak boleh kosong!");
      return;
    }

    dispatch(sendCheckOnlineId(form.onlineId));
  };

  const activateLaterHandler = (e) => {
    form.activateLater = e.target.checked;
    if (form.domainForwarder === null) {
      setForm((prev) => ({
        ...prev,
        domainForwarder: "Activate Later",
      }));
    }
    handleSubmit(null);
  };

  return (
    <>
      <Modal show={props.show} onHide={props.onHide} backdrop="static" centered>
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Bundle Domain</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-muted fs-6">
              Silahkan isi dengan link marketplace atau website yang sudah anda
              buat
            </p>
            <div className="row">
              <div className="mb-3">
                <label
                  htmlFor="forward-domain"
                  className="form-label label-qwords"
                >
                  Forward Domain
                  <OverlayTrigger
                    placement={"right"}
                    overlay={
                      <Tooltip>
                        Untuk menggunakan fitur domain forwarder, Anda perlu
                        menggunakan nameserver Golden Fast Network: [dns1.goldenfast.id,
                        dns2.goldenfast.id, dnsiix1.goldenfast.net, dnsiix2.goldenfast.net]
                      </Tooltip>
                    }
                  >
                    <span
                      className="d-inline-block px-2 py-0 ms-1 fw-bold text-white"
                      style={{
                        backgroundColor: "#959595",
                        cursor: "pointer",
                        borderRadius: "50%",
                        fontSize: "12px",
                      }}
                    >
                      i
                    </span>
                  </OverlayTrigger>
                </label>
                <input
                  type="url"
                  className="form-control input-modal"
                  id="forward-domain"
                  placeholder="e.g. https://shopee.com/my_awesome_store"
                  onChange={handleDomainForwarder}
                  value={form.domainForwarder || ""}
                />
              </div>
              {(!isLogin || !onlineIdExist) && (
                <div className="mb-3">
                  <label
                    htmlFor="online-id"
                    className="form-label label-qwords"
                  >
                    Online.id
                  </label>
                  <div className="input-group">
                    <label className="label-qwords input-group-text">
                      online.id/
                    </label>
                    <input
                      type="text"
                      className="form-control input-modal"
                      id="online-id"
                      placeholder="e.g. my_awesome_store"
                      onChange={handleOnlineId}
                      value={form.onlineId || ""}
                    />
                    <button
                      className="btn btn-outline-warning"
                      type="button"
                      id="button-addon2"
                      onClick={handleCheck}
                      disabled={isChecking}
                    >
                      {isChecking ? "Checking..." : "Check"}
                    </button>
                  </div>
                  <div id="emailHelp" className="form-text mt-3">
                    *) Khusus pengguna baru Qwords.com atau yang belum terdaftar
                    di{" "}
                    <a href="https://online.id" target="__blank" style={{ textDecoration: 'none' }}>
                      Online.id
                    </a>
                    .
                  </div>
                  <div className="text-muted mt-1">
                    <small
                      className={`${data?.available ? "text-success fw-bold" : "text-danger fw-bold"
                        }`}
                    >
                      {isChecking
                        ? "..."
                        : `${data?.available
                          ? "Available"
                          : "Not Available, try another keyword."
                        }`}
                    </small>
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-grid gap-2 col-6 mx-auto">
              <button type="submit" className="btn btn-cta w-100">
                Simpan
              </button>
            </div>
          </Modal.Footer>
          <div className="mt-5" style={{ paddingLeft: "36px" }}>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className={`btn ${form.activateLater ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={activateLaterHandler}
              >
                {form.activateLater ? "Aktifkan Sekarang" : "Aktifkan Nanti"}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default ModalBundleDomain;
